import i18n from '@/i18n';
import { ApiError, apiRequest, ErrorCode } from '@/lib/api/client';

/**
 * Log level enum
 */
export enum LogLevel {
  DEBUG = 'DEBUG',
  INFO = 'INFO',
  WARN = 'WARN',
  ERROR = 'ERROR',
}

/**
 * Log type definition
 */
export interface Log {
  id: number;
  timestamp: string;
  level: LogLevel;
  message: string;
  file?: string;
  line?: number;
  createdAt: string;
}

/**
 * Standard response type definition
 */
export interface StandardResponse<T> {
  data: T;
  status: number;
  message: string;
  meta?: {
    pagination?: {
      total: number;
      limit: number;
      offset: number;
    };
    [key: string]: unknown;
  };
}

/**
 * Log list response type definition
 */
export type LogListResponse = StandardResponse<Log[]>

/**
 * Log retrieval parameters type definition
 */
export interface GetLogsParams {
  level?: LogLevel;
  since?: string;
  until?: string;
  limit?: number;
  offset?: number;
}

/**
 * Get log list
 * @param params Search criteria
 * @returns Log list response
 */
export async function getLogs(params?: GetLogsParams): Promise<LogListResponse> {
  try {
    return await apiRequest<LogListResponse>({
      method: 'GET',
      path: '/cms/logs',
      params: params as Record<string, string | number | undefined>,
    });
  } catch (error) {
    if (error instanceof ApiError) {
      throw error;
    }
    throw new ApiError(
      i18n.t('common:errors.logRetrievalFailed'),
      ErrorCode.UNKNOWN_ERROR,
      500,
    );
  }
}
